import Vue from "vue";

export default {
    SET_USER_STICKER_LIST: (state, {stickerList, userId}) => {
        Vue.set(state.stickerList, userId, stickerList.map((v) => {return {...v, setting: JSON.parse(v.setting)}}));
    },
    SET_STICKER_LIST: (state, {data}) => {
        state.stickers = data;
    },
    SET_STICKER_ITEM: (state, {itemId, data}) => {
        Vue.set(state.stickerItems, itemId, data);
    }
}